import { Outlet } from "react-router-dom";
import React, { useEffect } from "react";
import { fetchImages } from "../pages/filmes/movie-images";
import { fetchImages as fetchDevImages } from "../pages/em-desenvolvimento/movie-images";

export async function loader() {
    const jsonData = await require(`../pages/filmes/data.json`);
    const devData = await require(`../pages/em-desenvolvimento/data.json`);
    return {
        ...jsonData,
        filmes: fetchImages(jsonData.filmes),
        filmesEmDesenvolvimento: fetchDevImages(devData.filmes),
    };
}

const Main = ({className}) => {
    const [jsonData, setJsonData] = React.useState({filmes: [], filmesEmDesenvolvimento: []});

    useEffect(() =>{
        loader().then(data => setJsonData(data));
    },[]);
    
    return (
        <div className={`main ${className ?? ''}`}>
            <Outlet context={[jsonData, setJsonData]} />
        </div>
    )
}

export default Main;